import axios from 'axios'

// _m12tk10q === token
// _d11ed20d === expirationDate

const state = {
    token: null,
    user: null
}

const getters = {
    authenticated (state) {
        // perfectly ensure user is signed correctly
        if(state.token === null || JSON.stringify(state.user) === '{}'){
            return false
        }
        return true
    },
    user (state) {
        return state.user
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {
    // get a token for this user signin action
    async signIn({ dispatch }, userObj) {
        // first empty out any cached users data before proceeding to sign them in
        dispatch('emptyThem')

        // proceed to sign user in via apin
        let response = await axios.post('/users/signin', userObj)
        
        // only return response data on failed signin attempts
        if(response.data.error){ 
            return response.data    
        }
        // proceed with sign in process
        let token = response.data.result
        return dispatch('attempt', token)
    },
    
    // sign in to get the user full details
    async attempt ({ dispatch, getters, commit, state }, token) {
        if(token) {
            commit('SET_TOKEN', token)
        }

        if(!state.token) {
            return
        }
        
        // check if local storage token still exists
        let lsToken = localStorage.getItem('_m12tk10q')
        if(!lsToken){
            dispatch('signOut')
            return
        }
        
        // check if time has passed expirationDate
        let expirationDate = localStorage.getItem('_d11ed20d')
        let now = Date()
        if(now >= expirationDate){
            // dispatch('signOut')
            // return
            // FIX ME MY EXPIRATION DATE NOW
        }

        try {
            let response = await axios.post('/users/me', {token})

            if(response.data !== null){
                // incase another user was being looked up
                dispatch('closeLookedupUserH')

                // fetch token expiration time
                let expiresIn = response.data.result.expiresIn
    
                // determine the expirationDate 
                let currentTime = new Date()
                let expirationDate = new Date(currentTime.getTime() + expiresIn)
    
                // store the users token and expiration time in the browser localStorage to enable auto login
                localStorage.setItem('_d11ed20d', expirationDate) // expirationDate

                // auto log out user if the user has stayed logged in over the expected duration i.e Date.now() > expiresIn
                dispatch('setSignOutTimer', expiresIn)

                // fetch my liked items array if any
                let userObj = { userId: response.data.result._id }
                dispatch('fetchMyLikedItems', userObj)

                // fetch my relationships here - followers and following
                dispatch('fetchRelationships', userObj)

                // fetch my connections here - blocked and referrals
                dispatch('fetchConnections', userObj)
                
                // fetch my ratings here - stars and reviews
                dispatch('fetchMyReviews', userObj)

                // fetch and store intlShopping countries
                dispatch('fetchCountries', 'international')
                
                // fetch and update users shop+ billing record
                dispatch('fetchBillings', userObj)
                
                // fetch the shoppers past orders
                dispatch('fetchOrdersAction', userObj)
                
                // fetch the shoppers saved addresses
                dispatch('fetchAddressesAction', userObj)
            }

            // update with the token with the newly recieved token from api when page was reloaded
            commit('SET_TOKEN', response.data.result.token)

            // update the logged in user details
            dispatch('updateUserVal', response.data.result)

            // check if the user was previously logged into shop and re-log user into shop
            let lsShopToken = localStorage.getItem('_t13st40q')
            if(lsShopToken){
                let shopObj = {
                    userId: response.data.result._id,
                    shopToken: lsShopToken
                }
                // re-log user into shop :: the return keyword is important else user won't get redirected to shop!
                return dispatch('fetchShop', shopObj)
            }
        }
        catch(e) {
            commit('SET_TOKEN', null)
            dispatch('updateUserVal', null)
        }
    },
    setSignOutTimer({ dispatch }, payload){
        setTimeout(() => {
            dispatch('signOut')
        }, payload)
    },

    async recoveryLink({ _ }, userObj) {
        let response = await axios.post(`/security/passwordRecovery`, userObj)
        return response.data
    },

    async resetPassword({ _ }, userObj) {
        let response = await axios.post(`/security/resetPassword`, userObj)
        return response.data
    },

    async updateUserVal({ commit, getters }, userObj) { 
        // wipe out the vuex-stored content of the currently logged in user
        if(userObj === null){
            return commit('SET_USER', null)
        }

        // ensure the encrypted-password property is deleted if it was included
        if(userObj.password) { delete userObj.password }
        
        // get the current content of getters.user then append/update the new values onto it
        let occupantObj = getters.user
        let incomingObj = userObj
        let combinedObj = {...occupantObj, ...incomingObj}
        return commit('SET_USER', combinedObj)
    },
}

const mutations = {
    SET_TOKEN: (state, userToken) => (state.token = userToken),
    SET_USER: (state, userObj) => (state.user = userObj)
}

export default {
    state,
    getters,
    actions,
    mutations
}